import * as yup from 'yup'

export const createSupplierMappingSchema = (isEdit: boolean) =>
  yup.object().shape({
    product_ids: yup
      .array()
      .min(1, 'At least one product must be selected')
      .required('Products are required'),
  })
